import { Reveal, SectionHeading } from "./Reveal";
import { GALLERY } from "../data/site";

export const Gallery = () => (
    <section id="galleria" data-testid="gallery-section" className="py-24 sm:py-36">
        <div className="max-w-7xl mx-auto px-5 sm:px-8">
            <SectionHeading
                index="05"
                eyebrow="Galleria"
                title="Dentro la nostra clinica."
                testId="gallery-heading"
            />

            <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-5">
                {GALLERY.map((img, i) => (
                    <Reveal key={img.label} delay={i * 0.06}>
                        <figure
                            data-testid={`gallery-item-${i}`}
                            className="group relative overflow-hidden rounded-2xl border border-white/10 aspect-[4/3]"
                        >
                            <img
                                src={img.src}
                                alt={img.label}
                                loading="lazy"
                                className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-[filter,transform] duration-700"
                            />
                            <div className="absolute inset-0 bg-black/30 group-hover:bg-black/0 transition-colors duration-700" />
                            <figcaption className="absolute bottom-0 left-0 right-0 p-5 sm:p-6 flex items-end justify-between">
                                <span className="text-xs uppercase tracking-[0.2em] text-white/80">
                                    {img.label}
                                </span>
                                <span className="font-display italic text-white/30 text-lg">
                                    0{i + 1}
                                </span>
                            </figcaption>
                        </figure>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
